import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { NotificationComponent } from "../notification.component";
import { NotificationService } from '../notification.service';

/**
 * A single instance of this component should be placed in the app.component.html
 */
@Component({
  selector: 'app-notifications-container',
  imports: [NotificationComponent],
  templateUrl: './notifications-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './notifications-container.component.scss'
})
export class NotificationsContainerComponent {
  public readonly NotificationService = inject(NotificationService);

  /**
   * Called by a notification when its display time is finished
   */
  public OnNotificationCloseAnimationFinished(notificationUniqueId: number): void{
    this.NotificationService.RemoveNotification(notificationUniqueId);
  }
}